"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var ory_editor_ui_1 = require("ory-editor-ui");

var ThemeProvider_1 = require("ory-editor-ui/lib/ThemeProvider");

var state_1 = require("../default/state");
/*const changeUrl = (onChange: (state: Html5VideoState) => void) => (
  event: React.ChangeEvent<HTMLInputElement>
) => event.target && onChange({ url: event.target.value });*/


var Html5VideoDefaultControls = function Html5VideoDefaultControls(props) {
  var _a = props.state,
      url = (_a === void 0 ? state_1.defaultHtml5VideoState : _a).url,
      commitUrl = props.commitUrl,
      changeUrlPreview = props.changeUrlPreview,
      focused = props.focused,
      readOnly = props.readOnly;
  return React.createElement("div", {
    className: "ory-content-plugin-html5-video"
  }, !readOnly && focused && React.createElement(ory_editor_ui_1.BottomToolbar, {
    open: focused,
    theme: ThemeProvider_1.darkTheme
  }, React.createElement(TextField_1.default, {
    placeholder: "https://example.com/video.webm",
    label: "Video url",
    onChange: function onChange(e) {
      return changeUrlPreview(e.target.value);
    },
    onBlur: commitUrl,
    value: url,
    style: {
      width: '512px'
    }
  })), React.createElement(props.Renderer, __assign({}, props)));
};

exports.default = Html5VideoDefaultControls;